<div class="row">
    <div class="col-12">
        <div class="row">
            <div class="col-md-6">
                <sf-card>
                    <h5>Single Message</h5>
                    <form [formGroup]="singleUserform" (ngSubmit)="sendSingle()">
                        <sf-input-dropdown
                            label="Staff"
                            inputId="staff"
                            [items]="staff$ | async"
                            bindLabel="username"
                            bindValue="username"
                            formControlName="username"
                        ></sf-input-dropdown>
                        <sf-input label="Title" inputId="title" formControlName="title"></sf-input>
                        <sf-input-textarea
                            label="Message"
                            inputId="message"
                            formControlName="message"
                        ></sf-input-textarea>
                        <sf-input-dropdown
                            label="type"
                            inputId="type"
                            [items]="types"
                            formControlName="type"
                        ></sf-input-dropdown>
                        <button sfButton type="submit" color="success" class="mt-3">Send</button>
                    </form>
                </sf-card>
            </div>
            <div class="col-md-6">
                <sf-card>
                    <h5>Group Message</h5>
                    <form [formGroup]="groupForm" (ngSubmit)="sendGroupMessage()">
                        <sf-input label="Title" inputId="title" formControlName="title"></sf-input>
                        <sf-input-textarea
                            label="Message"
                            inputId="message"
                            formControlName="message"
                        ></sf-input-textarea>
                        <sf-input-dropdown
                            label="type"
                            inputId="type"
                            [items]="types"
                            formControlName="type"
                        ></sf-input-dropdown>
                        <button sfButton type="submit" color="success" class="mt-3">Send</button>
                    </form>
                </sf-card>
            </div>
        </div>
    </div>
</div>
